import { useState, useEffect, useContext } from "react";
import { useLocation, Link } from "react-router-dom";
import Posts from "../../components/posts/Posts";
import Pagination from "../../components/Pagination/Pagination";
import "./homepage.css";
import { postsApi } from "../../services";
import { Context } from "../../Context/Context";
import FormChangePwd from "../../components/Form/FormChangePwd";

const PAGE_SIZE = 12;

export default function Homepage() {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { search } = useLocation();
  const { toggleForm } = useContext(Context);
  const [active, setActive] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsData = await postsApi.getAllPosts(search);
        setPosts(postsData);
        setFilteredPosts(postsData);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };
    fetchPosts();
  }, [search]);

  // Search functionality
  useEffect(() => {
    const filtered = posts.filter(post =>
      post.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPosts(filtered);
  }, [searchTerm, posts]);

  useEffect(() => {
    if (toggleForm) {
      document.body.style.overflow = "hidden";
      window.scrollTo(0, 0);
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [toggleForm]);

  // Compute display posts
  const displayPosts = active === "crossFire" || active === "lienquan" || active === "freefire" || active === "guide"
    ? filteredPosts.filter((post) => post.thumb === active)
    : filteredPosts;

  // Reset to first page whenever the result set changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, active, posts]);

  const totalPages = Math.ceil(displayPosts.length / PAGE_SIZE);
  const pagedPosts = displayPosts.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  return (
    <>
      <div className="page-header">
        {/* Row 1 — title + primary action */}
        <div className="page-header-top">
          <div className="page-title">
            <h1>Quản lý tài khoản</h1>
          </div>
          <div className="toolbar-actions">
            <Link to="/write" className="btn btn-primary">
              <i className="fas fa-plus"></i>
              <span>Tạo tài khoản</span>
            </Link>
          </div>
        </div>

        {/* Row 2 — search + filter */}
        <div className="page-toolbar">
          <div className="toolbar-search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Tìm kiếm theo tên tài khoản..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="toolbar-filter">
            <span className="filter-bar-label">Loại:</span>
            <select
              className="filter-select"
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              <option value="">Tất cả</option>
              <option value="crossFire">CrossFire</option>
              <option value="lienquan">Liên Quân</option>
              <option value="freefire">Free Fire</option>
              <option value="guide">Hướng dẫn</option>
            </select>
            {active !== "" && (
              <button className="filter-reset-btn" onClick={() => setActive("")}>
                <i className="fas fa-times"></i> Xóa bộ lọc
              </button>
            )}
            <span className="filter-summary-inline">
              Hiển thị <strong>{displayPosts.length}</strong> tài khoản
            </span>
          </div>
        </div>
      </div>

      {/* Posts Grid */}
      <div className="posts-container">
        {displayPosts.length === 0 ? (
          <div className="no-results">
            <div className="no-results-icon">
              <i className="fas fa-search"></i>
            </div>
            <h3>Không tìm thấy tài khoản nào</h3>
            <p>
              {searchTerm
                ? `Không có tài khoản nào phù hợp với từ khóa "${searchTerm}"`
                : "Không có tài khoản nào trong danh mục này"
              }
            </p>
          </div>
        ) : (
          <Posts posts={pagedPosts} />
        )}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />

      {toggleForm && <FormChangePwd />}
    </>
  );
}
